<template>
  <v-card>
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" :lg="isZAWill ? 6 : 12">
          <h4>Burial preference:</h4>
          <p>{{ burialPreference }}</p>

          <h4>Last note:</h4>
          <div v-if="testator.letterOfWishes" class="letter-of-wishes">
            {{ testator.letterOfWishes }}
          </div>
          <p v-else>No last note</p>
        </v-col>
        <v-col v-if="isZAWill" cols="12" lg="6">
          <h3>Living Will</h3>
          <h4>
            Create Living Will: <span>{{ includeLivingWill }}</span>
          </h4>
          <div v-if="testator.livingWill" class="mt-2">
            <h4>Living will decision maker:</h4>
            <p>
              {{ relations.livingWillDecisionMaker.fullName }} -
              {{
                formatPersonKinship(relations.livingWillDecisionMaker.kinship)
              }}
            </p>

            <h4>
              Kept alive by artificial means:
              <span>{{ keptAliveByArtificialMeans }}</span>
            </h4>

            <h4>
              Resuscitate: <span>{{ resuscitate }}</span>
            </h4>

            <h4>
              Comfort care: <span>{{ comfortCare }}</span>
            </h4>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { formatKinship } from '../../../constants/js/people';

  export default {
    name: 'LetterOfWishesCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
      relations: {
        required: true,
        type: Object,
      },
    },
    computed: {
      title() {
        if (this.isZAWill) {
          return 'Living Will & Letter of wishes';
        } else {
          return 'Letter of wishes';
        }
      },
      includeLivingWill() {
        if (this.testator.includeLivingWill) {
          return 'Yes';
        } else if (this.testator.includeLivingWill == false) {
          return 'No';
        } else {
          return 'No option selected yet';
        }
      },
      burialPreference() {
        switch (this.testator.burialPreference) {
          case 'BURIAL':
            return 'Burial';
          case 'CREMATION':
            return 'Cremation';
          case 'ORGAN_DONOR':
            return 'Organ donor';
          case 'ORGAN_DONOR_BURIAL':
            return 'Organ donor then burial';
          case 'ORGAN_DONOR_CREMATION':
            return 'Organ donor then cremation';
          case 'SCIENTIFIC_RESEARCH':
            return 'Scientific research';
          case 'OTHER':
            return this.testator.burialPreferenceOther;
          default:
            return 'No burial preference selected';
        }
      },
      keptAliveByArtificialMeans() {
        if (this.testator.livingWill.keptAliveByArtificialMeans) {
          return (
            'Yes - ' +
            this.testator.livingWill.keptAliveTimeAmount +
            ' ' +
            this.testator.livingWill.keptAliveTimePeriod.toLowerCase()
          );
        } else {
          return 'No';
        }
      },
      resuscitate() {
        return this.testator.livingWill.resuscitate ? 'Yes' : 'No';
      },
      comfortCare() {
        return this.testator.livingWill.comfortCare ? 'Yes' : 'No';
      },
      isZAWill() {
        return this.testator.willCountry == 'ZA';
      },
    },
    methods: {
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
    },
  };
</script>

<style lang="scss" scoped>
  h4 span {
    font-weight: normal;
  }
</style>
